import React from 'react';

const Freight = (props) => (
    <svg
        width="22px"
        height="19px"
        viewBox="0 0 22 19"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        {...props}
    >
        <title>Icon/FM b@1.5x</title>
        <g id="Gscope---Left-Navigation" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Gscope_icons" transform="translate(-388.000000, -1924.000000)" fill="#000000" fill-rule="nonzero">
                <g id="Icon/FM-b" transform="translate(388.000000, 1924.000000)">
                    <path
                        d="M14,3.8 C14.9214907,3.8 15.6263991,4.59060055 15.6945862,5.54760258 L15.7,5.7 L15.7,10.5 L14.3,10.5 L14.3,5.7 C14.3,5.43619179 14.1733497,5.25123545 14.0515296,5.20911837 L14,5.2 L4,5.2 C3.88224316,5.2 3.74087329,5.35198032 3.70737077,5.59195356 L3.7,5.7 L3.7,10.5 L2.3,10.5 L2.3,5.7 C2.3,4.72721111 2.95883379,3.88797111 3.85636257,3.80647908 L4,3.8 L14,3.8 Z"
                        id="Path"
                    ></path>
                    <path
                        d="M8,0.4 C8.35438271,0.4 8.64725823,0.663343623 8.69360983,1.00501415 L8.7,1.1 L8.7,4.5 L7.3,4.5 L7.3,1.799 L6.7,1.799 L6.7,4.5 L5.3,4.5 L5.3,1.1 C5.3,0.745617286 5.56334362,0.45274177 5.90501415,0.406390175 L6,0.4 L8,0.4 Z"
                        id="Path"
                    ></path>
                    <path
                        d="M10.5,6.8 C10.8865993,6.8 11.2,7.11340068 11.2,7.5 C11.2,7.85438271 10.9366564,8.14725823 10.5949859,8.19360983 L10.5,8.2 L5.5,8.2 C5.11340068,8.2 4.8,7.88659932 4.8,7.5 C4.8,7.14561729 5.06334362,6.85274177 5.40501415,6.80639017 L5.5,6.8 L10.5,6.8 Z"
                        id="Line"
                    ></path>
                    <path
                        d="M21,9.8 L1,9.8 C0.462524132,9.8 0.125567094,10.3806375 0.392229801,10.8472973 L4.3922298,17.8472973 C4.5168598,18.0653998 4.74880021,18.2 5,18.2 L17,18.2 C17.2511998,18.2 17.4831402,18.0653998 17.6077702,17.8472973 L21.6077702,10.8472973 C21.8744329,10.3806375 21.5374759,9.8 21,9.8 Z M19.793,11.2 L16.593,16.8 L5.406,16.8 L2.206,11.2 L19.793,11.2 Z"
                        id="Rectangle"
                    ></path>
                </g>
            </g>
        </g>
    </svg>
);

export default Freight;
